"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("./enhancers/index");

function expandAliases(props) {
  var propNames = Object.keys(props);
  var newProps = new Map();
  propNames.forEach(function (propName) {
    var propValue = props[propName];
    var aliases = index_1.propAliases[propName] || [propName];

    if (process.env.NODE_ENV !== 'production') {
      var validator = index_1.propValidators[propName];

      if (validator) {
        var result = validator(propValue);

        if (result) {
          throw new Error("\uD83D\uDCE6 ui-box: ".concat(result));
        }
      }
    }

    aliases.forEach(function (alias) {
      newProps.set(alias, propValue);
    });
  });
  return newProps;
}

exports.default = expandAliases;